import { outlinedInputClasses, styled } from '@mui/material';
import { TextFieldUncontrolled } from '../TextField';
export const TextFieldUncontrolledHighlighted = styled(TextFieldUncontrolled, {
    shouldForwardProp: (prop) => prop !== 'highlighted',
})(({ theme, highlighted }) => highlighted
    ? {
        [`:not(.Mui-focused) .${outlinedInputClasses.notchedOutline}`]: {
            boxShadow: `rgb(255, 255, 255) 0px 0px 0px 0px inset, ${theme.palette.success.dark} 0px 0px 0px 2px inset, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px`,
        },
    }
    : undefined);
